import { render } from "./OperationsDetails.vue?vue&type=template&id=07f42bc3&scoped=true"
import script from "./OperationsDetails.vue?vue&type=script&lang=js"
export * from "./OperationsDetails.vue?vue&type=script&lang=js"

import "./OperationsDetails.vue?vue&type=style&index=0&id=07f42bc3&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f42bc3"]])

export default __exports__